export default {
  row1 :  [
    {
      column: "column1",      
      rows: {
        row1: [
          {
            name: "enabled",
            label: "Enabled",
            component: "togglebutton",
            width: "100%",
          },
        ],        
        row2: [
            {
              name: "Integration Type",
              label: "Integration Type",
              component: "dropdown",
              placeholder:"Search name",
              width : "45%",
            },
          ],
          row3: [
            {
              name: "Parent Type",
              label: "Parent Type",
              component: "dropdown",
              placeholder:"Search name",
              width : "45%",
            },
          ],
      },
    },
  ]
   
}
   
       
      
  
  
